var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElSelect',_vm._g(_vm._b({attrs:{"value":_vm.value,"multiple":"","filterable":"","remote":""},on:{"input":_vm.handleInput}},'ElSelect',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",null,{"data":_vm.finalData})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }